module.exports = JSON.parse('{"Measurements":"Measurements","Studies":"Studies"}')